import type * as React from 'react';
import { useIntl } from 'react-intl';

import { Styled } from './tooltip.style';

export type ToolTipProps = {
  id: string;
  onClick?: () => void;
  children: React.ReactNode;
};

export const ToolTip: React.FC<ToolTipProps> = ({ id, onClick, children }) => {
  const intl = useIntl();
  const name = intl.formatMessage({ id, defaultMessage: '' });

  return (
    <Styled.ToolTip
      onClick={onClick}
      title={name}
      aria-label={name}
      role="tooltip"
    >
      {children}
    </Styled.ToolTip>
  );
};
